import {
  ActionTypes,
  AuthorizeUserAction,
  SetUserId,
  OAuthData,
  LogoutUserAction,
  SetCookies,
  SetServerDown,
  SetIdled,
} from './types';

const setOAuthWithUser = (payload: OAuthData): AuthorizeUserAction => ({
  type: ActionTypes.AUTHORIZE_USER,
  payload: {
    token: payload.token,
    isLogin: payload?.isLogin,
    isAuthenticated: true,
    refresh: payload?.refresh,
    expires: payload?.expires,
  },
});

const setOAuthWithClient = (payload: OAuthData): AuthorizeUserAction => ({
  type: ActionTypes.AUTHORIZE_USER,
  payload: {
    token: payload.token,
    isLogin: false,
    isAuthenticated: true,
    refresh: undefined,
    expires: payload?.expires,
  },
});

const setUserId = (payload: string): SetUserId => ({
  type: ActionTypes.SET_USERID,
  payload,
});

const logOut = (): LogoutUserAction => ({
  type: ActionTypes.LOGOUT_USER,
});

const setCookies = (payload: boolean): SetCookies => ({
  type: ActionTypes.SET_COOKIES,
  payload,
});

const setServerDown = (payload: boolean): SetServerDown => ({
  type: ActionTypes.SET_SERVER_DOWN,
  payload,
});

const setIdled = (payload: string | undefined): SetIdled => ({
  type: ActionTypes.SET_IDLED,
  payload,
});

export { setOAuthWithUser, setOAuthWithClient, setUserId, logOut, setCookies, setServerDown, setIdled };
